export const CHECKED_ID = 'RESOURCES/CHECKED_ID';
export const UNCHECKED_ID = 'RESOURCES/UNCHECKED_ID';

export function idChecked(id) {
  return {
    type: CHECKED_ID,
    payload: id,
  };
}

export function idUnchecked(id) {
  return {
    type: UNCHECKED_ID,
    payload: id,
  };
}
